<template>
  <div>
    <search-form
      :fetchData="fetch"
      ref="searchFormRef"
      :handelSearch="handelSearch"
      :collection="formCollection"
    >
      <a-button
        @click="
          fileExport({
            name: `人员预约批量导入模板.zip`,
            url: `/api/personApplications/import/template`,
          })
        "
      >
        批量导入模板
      </a-button>
      &nbsp; &nbsp;
      <a-button @click="showAddModal" type="primary">批量导入</a-button>
    </search-form>
    <a-modal
      width="520px"
      v-model:open="open"
      :title="(isEdit ? '编辑' : '新增') + pageName"
      :footer="null"
      :destroyOnClose="true"
      :keyboard="false"
    >
      <action
        :v-if="open"
        @submit="clickOk"
        :isEdit="isEdit"
        :editData="editData"
        :disabled="disabled"
        :submitBtn="!disabled"
        :data="tableData"
        :idField="idField"
      ></action>
    </a-modal>
    <a-table
      :columns="columns"
      :row-key="(record) => record.uuid"
      :data-source="tableData"
      :pagination="pagination"
      :loading="loading"
      :scroll="{x: 'max-content'}"
      @change="handleTableChange"
      size="small"
    >
      <template #bodyCell="{ column, record }">
        <template v-if="column.key === 'status'">
          {{ codeToText(record.status, batchApplicationStatus) }}
        </template>
        <template v-else-if="column.key === 'file'">
          <a
            @click="
              fileExport({
                // name: `批量导入zip`,
                url: record.file_path,
              })
            "
          >
            点击下载
          </a>
        </template>
        <template v-else-if="column.dataInObject">
          {{
            record[column.dataInObject] &&
            record[column.dataInObject][column.dataIndex]
          }}
        </template>
        <template v-else-if="column.key === 'action'">
          <span>
            <a-button
              @click="showEditModal(record)"
              :loading="loadingRecord === record[idField] + 'edit'"
              v-if="record.status === 0 || record.status === 3"
            >
              编辑
            </a-button>
            <a-popconfirm
              title="确认开始导入？"
              ok-text="确认"
              cancel-text="取消"
              @confirm="submitImport(record)"
              v-if="record.status === 0 || record.status === 3"
            >
              <a-button>开始导入</a-button>
            </a-popconfirm>

            <a-popconfirm
              v-if="record.status === 0 || record.status === 3"
              title="确认删除？"
              ok-text="确认"
              cancel-text="取消"
              @confirm="delRow(record)"
            >
              <a-button danger>删除</a-button>
            </a-popconfirm>
          </span>
        </template>
      </template>
    </a-table>
    <approval_process
      v-model:openModal="approvalProcessOpen"
      :data="approvalProcessData"
    ></approval_process>
    <extension_application
      ref="extensionRef"
      url="personApplications"
    ></extension_application>
  </div>
</template>
<script setup>
  import { ref, onMounted, toRefs } from 'vue'
  import { useStore } from 'vuex'
  import {
    getData,
    deleteData,
    submit,
  } from '@/api/person_application/person_batch_application'
  import action from './action'
  import { message } from 'ant-design-vue'
  import { codeToText } from '@/utils/format'
  import searchForm from '@/components/search_form'
  import approval_process from '@/components/approval_process'
  import extension_application from '@/components/extension_application'
  import { batchApplicationStatus } from '@/utils/common'
  import { exponentialBackoffExecute } from '@/utils'
  import { fileExport } from '@/utils/download'

  //初始化
  const pageName = '批量导入'
  const idField = 'id' //响应数据的id的字段名
  const store = useStore()

  //1、搜索框
  const formCollection = []
  const searchFormRef = ref()
  function handelSearch() {
    pagination.value.current = 1
    fetch()
  }

  //2、表格
  const columns = [
    {
      title: '导入任务名',
      key: 'name',
      dataIndex: 'name',
      align: 'left',
    },
    {
      title: '文件大小(MB)',
      key: 'file_size',
      dataIndex: 'file_size',
      align: 'left',
    },
    {
      title: '文件',
      dataIndex: 'file',
      key: 'file',
      align: 'left',
    },
    {
      title: '创建人',
      dataIndex: 'user_name',
      key: 'user_name',
      dataInObject: 'createUser',
      align: 'left',
    },
    {
      title: '创建时间',
      dataIndex: 'create_time',
      key: 'create_time',
      align: 'left',
    },
    {
      title: '更新时间',
      dataIndex: 'update_time',
      key: 'update_time',
      align: 'left',
    },
    {
      title: '状态',
      dataIndex: 'status',
      key: 'status',
      align: 'left',
    },
    {
      title: '原因',
      dataIndex: 'reason',
      key: 'reason',
      align: 'left',
    },
    {
      title: '操作',
      dataIndex: 'action',
      key: 'action',
      align: 'left',
      fixed: 'right',
      width: 260,
    },
  ]

  const tableData = ref([])
  const loading = ref(false)
  const loadingRecord = ref()
  const pagination = ref({
    current: 1,
    pageSize: 10,
    showLessItems: true,
    showQuickJumper: true,
    showSizeChanger: true,
  })

  function handleTableChange(page) {
    pagination.value = { ...pagination.value, ...page }
    fetch()
  }

  function fetch() {
    //获取表单值
    const formState = searchFormRef.value?.formState

    loading.value = true
    getData({
      size: pagination.value.pageSize,
      pn: pagination.value.current,
      ...formState,
    }).then(({ data }) => {
      loading.value = false
      tableData.value = data.list
      pagination.value.total = data.total
    })
  }
  onMounted(fetch)

  //3、编辑、添加
  const open = ref(false)
  const isEdit = ref(false)
  const disabled = ref(false)
  const editData = ref(null)
  const showAddModal = () => {
    editData.value = null
    isEdit.value = false
    disabled.value = false
    open.value = true
  }
  const showEditModal = async (data) => {
    editData.value = data
    isEdit.value = true
    disabled.value = false
    open.value = true
  }

  function clickOk() {
    fetch()
    handleOk()
    clearEditData()
  }

  const handleOk = () => {
    open.value = false
  }
  const clearEditData = () => {
    editData.value = null
  }

  //4、删除
  async function delRow(data) {
    const res = await deleteData({ id: data[idField] })
    if (res.success) {
      message.success('删除成功！')
      fetch()
    } else {
      message.warn('删除失败' + res.message)
    }
  }

  //5、提交
  async function submitImport(data) {
    const res = await submit({ id: data[idField] })
    if (res.success) {
      message.success('提交成功！')
      // fetch()
      exponentialBackoffExecute(fetch)
    }
  }
</script>
